import React from 'react';

function IosIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
			<g>
				<path d="M10.48,9C8.9,9,8.1,10.42,8.1,12s.86,3,2.37,3,2.37-1.4,2.37-3.07C12.84,10.49,12.07,9,10.48,9Z"/>
				<path
					d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM5.88,15.7h-1V10.39h1Zm-.5-6.22a.57.57,0,0,1-.58-.57v0a.58.58,0,0,1,.58-.6h0a.6.6,0,0,1,0,1.2h0Zm5,6.34c-1.95,0-3.33-1.52-3.33-3.76s1.46-3.89,3.44-3.89,3.33,1.55,3.33,3.75c0,2.55-1.55,3.9-3.44,3.9Zm6.2,0a3.79,3.79,0,0,1-1.89-.47l.24-.8a3.35,3.35,0,0,0,1.72.48c1,0,1.55-.52,1.55-1.26s-.4-1.09-1.4-1.47c-1.21-.43-1.95-1.06-1.95-2.1a2.12,2.12,0,0,1,2.23-2h.17a3.42,3.42,0,0,1,1.63.37l-.26.78A2.89,2.89,0,0,0,17.24,9c-1,0-1.4.6-1.4,1.11,0,.69.45,1,1.47,1.42,1.26.49,1.89,1.09,1.89,2.18s-.84,2.13-2.59,2.13Z"/>
			</g>
		</svg>
	);
}

export default IosIcon;